"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _YesNoData = _interopRequireDefault(require("./components/YesNoData"));

var SECURITY_KEY = 'securityAudit';
var _default = {
  results: [new _YesNoData.default({
    localizedTextKey: 'results.security.https',
    resultFlipCard: true,
    resultKeyPath: [SECURITY_KEY, 'usesHttps']
  }), new _YesNoData.default({
    localizedTextKey: 'results.security.libraries',
    resultFlipCard: true,
    resultKeyPath: [SECURITY_KEY, 'hasNoVulnerableLibraries']
  })]
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/SecurityData.js
// module id = 147
// module chunks = 0